import { render, staticRenderFns } from "./Myfundmanager.vue?vue&type=template&id=6c022716&"
import script from "./Myfundmanager.vue?vue&type=script&lang=js&"
export * from "./Myfundmanager.vue?vue&type=script&lang=js&"
import style0 from "./Myfundmanager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports